/**
 * @readonly
 * @enum {string} an Enum containing all possible variants of exception types `KameleoonError`
 * */
export enum KameleoonException {
  Credentials = 'Credentials',
  EventSourceInitialization = 'EventSourceInitialization',
  FeatureFlagConfigurationNotFound = 'FeatureFlagConfigurationNotFound',
  FeatureFlagVariableNotFound = 'FeatureFlagVariableNotFound',
  FeatureFlagVariationNotFound = 'FeatureFlagVariationNotFound',
  FeatureFlagExperimentNotFound = 'FeatureFlagExperimentNotFound',
  FeatureFlagEnvironmentDisabled = 'FeatureFlagEnvironmentDisabled',
  VisitAmount = 'VisitAmount',
  VisitorCodeMaxLength = 'VisitorCodeMaxLength',
  VisitorCodeEmpty = 'VisitorCodeEmpty',
  StorageInitialization = 'StorageInitialization',
  StorageWrite = 'StorageWrite',
  StorageRead = 'StorageRead',
  StorageParse = 'StorageParse',
  StorageEmpty = 'StorageEmpty',
  ClientConfiguration = 'ClientConfiguration',
  TargetingCondition = 'TargetingCondition',
  AmongValuesCheck = 'AmongValuesCheck',
  RangeCheck = 'RangeCheck',
  Initialization = 'Initialization',
  JSONParse = 'JSONParse',
  NumberParse = 'NumberParse',
  VersionParse = 'VersionParse',
  CookieParse = 'CookieParse',
  SemanticVersionParse = 'SemanticVersionParse',
  RemoteData = 'RemoteData',
  MaximumRetriesReached = 'MaximumRetriesReached',
}
